var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14344",
    "data-name": "Group 14344",
    transform: "translate(-0.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14244",
    "data-name": "Group 14244",
    transform: "translate(8.073 1.212) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_109",
    "data-name": "Line 109",
    d: "M9.246,9.954l-9.6-9.6L.354-.354l9.6,9.6Z",
    transform: "translate(0 0)",
    fill: "#832729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_110",
    "data-name": "Line 110",
    d: "M.354,9.954l-.707-.707,9.6-9.6.707.707Z",
    transform: "translate(0 0)",
    fill: "#832729"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9926",
    "data-name": "Rectangle 9926",
    width: 16,
    height: 16,
    transform: "translate(0.073)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.520f7131cb4fe3c4a9bf0d260760abcb.svg";
export { ForwardRef as ReactComponent };